import './Register.css'
import mobile from '../Images/mobile.png'
import password from '../Images/password.png'
import barcode from '../Images/barcode.png'
import person from '../Images/person.png'
import instagram from '../Images/instagram3.png'
import telegram from '../Images/telegram3.png'
import gift from '../Images/gift.png'
import React, { useContext, useEffect, useState, useRef } from "react";
import { Link, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';
import http from "../Services/httpService";
import Services from "../Services/Services";
import { toast } from "react-toastify";

import whatsapp from '../Images/whatsapp3.png'
import Eitaa from '../Images/Eitaa3.png'
import bale from '../Images/bale3.png'

export default function QrCodeEdit() {
    const { id } = useParams();
    let navigate = useNavigate();
    useEffect(() => {
        if (id)
            doLoad(id);
    }, [id]);

    const [isLoading, setIsLoading] = useState(false);
    const doLoad = async (id) => {
        setIsLoading(true);
        await Services.QrCodeGet(id)
            .then(({ data }) => {
                setIsLoading(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                setForm(data.payload)
            })
            .catch(err => {
                setIsLoading(false);
            });
    }
    const formRef = useRef(null);
    const [isPosting, setIsPosting] = useState(false);
    const [form, setForm] = useState(
        {
            name: "", number1: "", number2: "", showData: "Show", instagram: "", telegram: "", comment: "", price: null,
        });

    useEffect(() => {
        const jwt = http.getLocalJwt();
        if (!jwt || jwt == "") {
            navigate('/login');
        }

    }, []);
    useEffect(() => {
        console.log('form', form)
    }, [form]);

    const handlePosting = async (e) => {
        e.preventDefault();
        const forms = formRef.current;
        if (forms.checkValidity() === false) {
            toast.error('داده های ورودی را بررسی بفرمایید', { theme: "colored" });
            forms.classList.add('was-validated')
            return;
        }
        setIsPosting(true);
        await Services.QrCodePost(form)
            .then(({ data }) => {
                setIsPosting(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                navigate('/main');
            })
            .catch(err => {
                setIsPosting(false);
            });
    }

    return (
        <>
            <div className="row mb-2">
                <div className="col d-flex justify-content-center">
                    <span className="text-white"> ثبت اطلاعات برچسب</span>
                </div>
            </div>
            {isLoading && <div className="spinner-border spinner-border-sm" role="status" />}
            {!isLoading &&
                <form ref={formRef} className=" needs-validation">

                    <div className="input-group mb-3">
                        <div className="input-group-text" >
                            <img
                                src={person}
                                className=" " />
                        </div>
                        <input
                            asp-for="name"
                            type="text"
                            name="name"
                            value={form.name}
                            onChange={e => http.handleChange(e, form, setForm)}
                            className="form-control"
                            placeholder="نام برچسب"
                            required
                            autoComplete="off" />
                        <span
                            asp-validation-for="name"
                            className="text-danger" />
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-text" >
                            <img
                                src={mobile}
                                className=" " />
                        </div>
                        <input
                            asp-for="number1"
                            type="number"
                            name="number1"
                            value={form.number1}
                            onChange={e => http.handleChange(e, form, setForm)}
                            className="form-control"
                            placeholder="شماره تماس"
                            required
                            autoComplete="off" />
                        <span
                            asp-validation-for="number1"
                            className="text-danger" />
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-text" >
                            <img
                                src={mobile}
                                className=" " />
                        </div>
                        <input
                            asp-for="number2"
                            type="number"
                            name="number2"
                            value={form.number2}
                            onChange={e => http.handleChange(e, form, setForm)}
                            className="form-control"
                            placeholder="شماره تماس آشنایان (اختیاری)"
                            autoComplete="off" />
                        <span
                            asp-validation-for="number2"
                            className="text-danger" />
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-text" >
                            <img
                                src={gift}
                                className=" " />
                        </div>
                        <input
                            asp-for="price"
                            type="text"
                            name="price"
                            value={form.price}
                            onChange={e => http.handleChange(e, form, setForm)}
                            className="form-control"
                            placeholder="مبلغ مژدگانی (اختیاری)"
                            autoComplete="off" />
                        <span
                            asp-validation-for="price"
                            className="text-danger" />
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-text" >
                            <img
                                src={instagram}
                                className=" " />
                        </div>
                        <input
                            asp-for="instagram"
                            type="text"
                            name="instagram"
                            value={form.instagram}
                            onChange={e => http.handleChange(e, form, setForm)}
                            className="form-control"
                            placeholder="آی دی اینستاگرام ( اختیاری )"
                            autoComplete="off" />
                        <span
                            asp-validation-for="instagram"
                            className="text-danger" />
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-text" >
                            <img
                                src={telegram}
                                className=" " />
                        </div>
                        <input
                            asp-for="telegram"
                            type="text"
                            name="telegram"
                            value={form.telegram}
                            onChange={e => http.handleChange(e, form, setForm)}
                            className="form-control"
                            placeholder="آی دی تلگرام ( اختیاری )"
                            autoComplete="off" />
                        <span
                            asp-validation-for="telegram"
                            className="text-danger" />
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-text" >
                            <img
                                src={whatsapp}
                                className=" " />
                        </div>
                        <input
                            asp-for="whatsapp"
                            type="text"
                            name="whatsapp"
                            value={form.whatsapp}
                            onChange={e => http.handleChange(e, form, setForm)}
                            className="form-control"
                            placeholder="واتس آپ"
                            autoComplete="off" />
                        <span
                            asp-validation-for="whatsapp"
                            className="text-danger" />
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-text" >
                            <img
                                src={bale}
                                className=" " />
                        </div>
                        <input
                            asp-for="baleh"
                            type="text"
                            name="baleh"
                            value={form.baleh}
                            onChange={e => http.handleChange(e, form, setForm)}
                            className="form-control"
                            placeholder="بله"
                            autoComplete="off" />
                        <span
                            asp-validation-for="baleh"
                            className="text-danger" />
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-text" >
                            <img
                                src={Eitaa}
                                className=" " />
                        </div>
                        <input
                            asp-for="eita"
                            type="text"
                            name="eita"
                            value={form.eita}
                            onChange={e => http.handleChange(e, form, setForm)}
                            className="form-control"
                            placeholder="ایتا"
                            autoComplete="off" />
                        <span
                            asp-validation-for="eita"
                            className="text-danger" />
                    </div>
                    <div className="input-group mb-3">
                        <textarea
                            asp-for="comment"
                            type="text"
                            name="comment"
                            value={form.comment}
                            onChange={e => http.handleChange(e, form, setForm)}
                            className="form-control"
                            placeholder="توضیحات (اختیاری)"
                            rows={3}
                            autoComplete="off" />
                    </div>
                    <div className="form-check mt-4 mb-4">
                        <input
                            className="form-check-input"
                            type="checkbox"

                            name="Password"
                            onChange={(e) => {
                                setForm({ ...form, showData: e.target.checked ? 'Show' : 'Hide' });
                            }}
                            checked={form.showData == "Show"}
                        />
                        <label className="form-check-label text-white" htmlFor="checkIndeterminate">
                            شماره تماس نمایش داده شود.
                        </label>
                    </div>
                    <div className='row'>
                        <div className='col'>
                            <button
                                className="w-100 btn btn-lg btn1 py-3"
                                onClick={handlePosting}
                                disabled={isPosting}>
                                ثبت اطلاعات
                                {isPosting &&
                                    <div className="spinner-border spinner-border-sm" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>}
                            </button>
                        </div>
                    </div>
                </form>
            }
            <div className="row mt-4">
                <div className="col d-flex justify-content-center">
                    <Link
                        className="textColor1 text-decoration-none ms-1"
                        to="/main"> لیست برچسب ها</Link>
                </div>
            </div>
        </>

    );

}
